var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"my-button",class:[_vm.type, _vm.size],attrs:{"to":this.link}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }